import { useSelector } from "react-redux";
import { Feature, SetupType } from "../../models/features/Integration/DmsSetup";
import { AppState } from "../../redux/reducer/rootReducer";
import { FeatureFlags } from "../../models/auth/Auth";

export const featureMatrix: Record<Feature, SetupType[]> = {
  [Feature.LinkInventory]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],

  [Feature.VirtualShowroom]: [SetupType.Shopify, SetupType.ShopifyLegacy],

  [Feature.HidePrice]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],

  [Feature.CustomPriceRule]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],

  [Feature.LocationMapping]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],
  [Feature.ProductsMatchingWithCatalog]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],
  [Feature.AppHealth]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],
  [Feature.SetupIdSharing]: [SetupType.HiImpact],
  [Feature.UsedProducts]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],
};

export const hasFeatureAccess = (
  setupType: SetupType | null | undefined,
  feature: Feature,
): boolean => {
  if (!setupType) return false;
  return featureMatrix[feature]?.includes(setupType) ?? false;
};

export const useFeatureFlag = (flagName: keyof FeatureFlags): boolean => {
  return useSelector(
    (state: AppState) =>
      state.authReducer.dmsSetup?.featureFlagSetting?.[flagName] ?? false,
  );
};
